export const formatCurrency = (amount: number): string => {
  return `${amount.toFixed(2)} JOD`;
};

export const formatPoints = (points: number): string => {
  return points.toString();
};
